if (!customElements.get('hero-slideshow')) {
  customElements.define(
    'hero-slideshow',
    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.hero-slideshow__slide'));
        this.dots = Array.from(this.querySelectorAll('.hero-slideshow__dot'));
        this.current = Math.max(
          this.slides.findIndex((slide) => slide.classList.contains('is-active')),
          0
        );
        this.speed = (Number(this.dataset.speed) || 5) * 1000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplayEnabled = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.hasFocus = false;

        if (this.initialized || this.slides.length < 2) return;
        this.initialized = true;

        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));

        this.addEventListener('focusin', () => {
          this.hasFocus = true;
          this.pause();
        });
        this.addEventListener('focusout', () => {
          this.hasFocus = false;
          this.play();
        });

        this.addEventListener('pointerdown', this.onPointerDown.bind(this));
        this.addEventListener('pointerup', this.onPointerUp.bind(this));
        this.addEventListener('pointercancel', () => (this.pointerStart = null));
        this.addEventListener('dragstart', (event) => event.preventDefault());
        // Don't follow a slide's link when the pointer was dragged to change slide
        this.addEventListener(
          'click',
          (event) => {
            if (!this.wasDragged) return;
            this.wasDragged = false;
            event.preventDefault();
            event.stopPropagation();
          },
          true
        );

        // Theme editor: show the slide that is being edited
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.indexOf(event.target);
          if (index === -1) return;
          this.editorSelected = true;
          this.goTo(index);
          this.pause();
        });
        this.addEventListener('shopify:block:deselect', () => {
          this.editorSelected = false;
          this.play();
        });

        this.reducedMotion.addEventListener('change', () => this.play());
        this.play();
      }

      disconnectedCallback() {
        this.pause();
      }

      goTo(index) {
        const next = (index + this.slides.length) % this.slides.length;
        if (next !== this.current) {
          this.current = next;

          this.slides.forEach((slide, i) => {
            slide.classList.toggle('is-active', i === next);
            if (i === next) slide.removeAttribute('aria-hidden');
            else slide.setAttribute('aria-hidden', 'true');
          });

          this.dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === next);
            if (i === next) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }

        this.play();
      }

      play() {
        this.pause();
        if (!this.autoplayEnabled || this.reducedMotion.matches || this.hasFocus || this.editorSelected) return;
        this.autoplay = setTimeout(() => this.goTo(this.current + 1), this.speed);
      }

      pause() {
        clearTimeout(this.autoplay);
      }

      onPointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.wasDragged = false;
        this.pointerStart = { x: event.clientX, y: event.clientY };
      }

      onPointerUp(event) {
        if (!this.pointerStart) return;
        const deltaX = event.clientX - this.pointerStart.x;
        const deltaY = event.clientY - this.pointerStart.y;
        this.pointerStart = null;

        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        this.wasDragged = true;
        this.goTo(this.current + (deltaX < 0 ? 1 : -1));
      }
    }
  );
}
